import { Outside, Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Area.css';
import { getAreaLabel } from './helpers';
import { IJsonQueryRangeValue } from '../../../types/jsonQuery';
import { useDebouncedCallback } from '../../../utils/useDebouncedCallback';
import { RangeInput } from '../../RangeInput';

interface IAreaProps {
  area: IJsonQueryRangeValue | null;
  onAreaMinChange(gte: number | null): void;
  onAreaMaxChange(lte: number | null): void;
}

export const Area: React.FC<IAreaProps> = ({ area, onAreaMinChange, onAreaMaxChange }) => {
  const { gte: areaMin = null, lte: areaMax = null } = area || {};

  const [isOpen, setIsOpen] = React.useState(false);

  const areaLabel = getAreaLabel(areaMin, areaMax);

  const handleClick = React.useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const handleClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleAreaMinChange = useDebouncedCallback(
    (gte: number | null) => {
      onAreaMinChange(gte);
    },
    300,
    [onAreaMinChange],
  );

  const handleAreaMaxChange = useDebouncedCallback(
    (lte: number | null) => {
      onAreaMaxChange(lte);
    },
    300,
    [onAreaMaxChange],
  );

  return (
    <Outside onOutside={handleClose} active={isOpen}>
      <div className={styles['container']}>
        <Button theme="stroke_secondary" size="XS" onClick={handleClick}>
          {areaLabel || 'Площадь'}
        </Button>
        {isOpen && (
          <div className={styles['dropdown']}>
            <RangeInput
              min={0}
              max={99999}
              joined={false}
              postfix={'м\u00b2'}
              valueMin={areaMin}
              valueMax={areaMax}
              onChangeMin={handleAreaMinChange}
              onChangeMax={handleAreaMaxChange}
            />
          </div>
        )}
      </div>
    </Outside>
  );
};
